"use strict";

exports.__esModule = true;
exports["default"] = isValid;

function isValid(error) {
  if (Array.isArray(error)) {
    return error.reduce(function (valid, errorValue) {
      return valid && isValid(errorValue);
    }, true);
  }
  return !error;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/isValid.js
// module id = 2142
// module chunks = 0